


























































































































































































































import { Component, Vue, Provide, Prop, Watch } from "vue-property-decorator";
import { localGet, timeFormat } from "@/utils";
import {API_COUNTRY} from '@/api/root';
import SupplierJson from "@/doc/Supplier.json"; //  lee 自己存储的供应商json
import id from "@/assets/i18n/langs/id";
const ContactTwoContactListDialogue = () =>
  import("./components/ContactTwoContactListDialogue.vue");
  const CalllogList = () =>
  import("./components/CalllogList.vue");
interface IContactList { }

@Component({
  name: "orderDialogue",
  components: {
    ContactTwoContactListDialogue,
    CalllogList
  },
})
export default class OrderDialogue extends Vue {
  @Provide() private country: any = localStorage.getItem("country");
  @Provide() private isTestDisabled: any = true;
  @Provide() private checkedWhatsapp: any = []; // 国家，字段差异化展示
  @Provide() private checkedWhatsappOther: any = []; // 额外联系人复选
  @Prop() isShowContact!: any; // 是否隐藏联系人信息
  @Prop() ticketData!: any; // 工单信息
  @Prop() whatsappflagMap!: any; // 工单信息
  @Prop() itemId!: any; // 工单id
  @Prop() identity!: any; // 本人身份证号码
  @Prop() customerId!: any; // 用户详情id
  @Prop() selfContactList!: any; // 本人其他联系人列表
  @Prop() contactSelfList!: any; // 本人其他联系人列表
  @Prop() ContactTwoContactList!: any; // 联系人二列表
  @Prop() CalllogList!: any; // 通话记录列表
  @Prop() isSelfContactList!: any; // 是否展示本人其他联系人列表
  @Prop() isEntrust!: boolean; // 是否委外 或是越南提醒工单
  @Prop() type!: boolean; // 是否催收工单
  @Prop() contactList!: any[]; // 联系人列表信息
  @Prop() providerOptions!: any[]; // 匹配供应商映射list
  @Prop() isShowSelfPhoneCopy!: any; // 是否展示本人手机号复制按钮
  @Prop() isShowOtherPhoneCopy!: any; // 是否展示联系人手机号复制按钮
  @Provide() contactListChild: any = []; // 匹配供应商映射list
  @Provide() contactSelfListChild: any = []; // 匹配供应商映射list
  @Provide() isContactListDialogue: boolean = false; // 是否展示联系人二的列表
  @Provide() isShowCallLog: boolean = false; // 是否展示calllog的列表
  @Provide() API_COUNTRY: any = API_COUNTRY; // 国家自定义

  private openNewNx(tel:any) {
    const message = {
      type: 'callOut',
      message: {
        type: 'callOut',
        content: {
          caller: '',
          callee: tel,
          countryCode: "57",
          orderId: this.ticketData.orderid,
          params: ""
        },
      }
    };
    window.postMessage(message, '*');
  }
  private created() {
    this.contactListChild = JSON.parse(JSON.stringify(this.contactList))

    this.contactSelfListChild = JSON.parse(JSON.stringify(this.contactSelfList))
    this.whatsappflagMap.forEach((em: any, ex: any) => {
      if (this.contactListChild.length > 0 && this.contactListChild[0].type == 'self') {
        if (em[0] == 0) {
          if (em[1] == 1) {
            this.checkedWhatsapp[em[0]] = true
          } else {
            this.checkedWhatsapp[em[0]] = false
          }
        } else {
          this.contactListChild.forEach((item: any, index: any) => {
            if (index == em[0]) {
              if (em[1] == 1) {
                this.checkedWhatsappOther[em[0]] = true
              } else {
                this.checkedWhatsappOther[em[0]] = false
              }
            }
          })
        }
      } else {
        if (em[0] == 0) {
          if (em[1] == 1) {
            this.checkedWhatsapp[em[0]] = true
          } else {
            this.checkedWhatsapp[em[0]] = false
          }
        } else {
          this.contactListChild.forEach((item: any, index: any) => {
            if (index + 1 == em[0]) {
              if (em[1] == 1) {
                this.checkedWhatsappOther[em[0] - 1] = true
              } else {
                this.checkedWhatsappOther[em[0] - 1] = false
              }
            }
          })
        }

      }

    })
    this.providerOptions.shift();
    this.contactListChild.map((item: any, index: any) => {
      item.isdisabledsave = true;
      item.saveType = '';
      return item;
    })
    this.contactSelfListChild.map((item: any, index: any) => {
      item.isdisabledsave = true;
      item.saveType = '';
      return item;
    })

    this.$route.query.autoCall && sessionStorage.getItem("phone") && this.callInfo();
  }
  // 呼叫当前信息
  private async callInfo() {
    const { dialerCurrentInfo }: any = await import("@/request/autoDial");
    let res = await dialerCurrentInfo();
    if (res) {
      if (+res.status === 1) {
        let supplier = res.supplier;
        let relation = +this.$route.query.phoneobject;
        let phone = sessionStorage.getItem("phone");
        this.makeDialog(phone, supplier, relation);
      }
    }
  }
  private onCopy(e: any) {
    this.$message.success("copy success");
  }
  private onError(e: any) {
    this.$message.success("copy failed");
  }
  private saveWhatsapp(index: number, flag: any) {
    if (flag == '99') {
      this.saveWhatsappFlagRequest(index, this.contactSelfListChild[index].checkedWhatsapp)
    } else {
      if (this.contactListChild[0].type == 'self') {
        this.saveWhatsappFlagRequest(index, this.contactListChild[index].checkedWhatsapp)
      } else {
        this.saveWhatsappFlagRequest(index + 1, this.contactListChild[index].checkedWhatsapp)
      }

    }

  }
  private async saveWhatsappFlagRequest(index: number, val: any) {
    const { setSaveWhatsappFlagReq, saveWhatsappFlagReqRequest }: any = await import(
      "@/request/getCustomerOtherMobile"
    );
    let data = await saveWhatsappFlagReqRequest.handleHttp(
      setSaveWhatsappFlagReq({
        ItemId: this.itemId,
        PhoneObject: String(index),
        HaveWhatsapp: val == true ? "1" : '0',
        TicketId: this.ticketData.id
      }),
      this
    );
    if (data && data.commonout.code == 0) {
      if (index == 0) {
        let arr = JSON.parse(JSON.stringify(this.contactSelfListChild));
        arr[index].isdisabledsave = true
        arr[index].saveType = ''
        this.$set(this.contactSelfListChild, index, arr[index]);
      } else {
        if (this.contactListChild[0].type == 'self') {
          let arr = JSON.parse(JSON.stringify(this.contactListChild));
          arr[index].isdisabledsave = true
          arr[index].saveType = ''
          this.$set(this.contactListChild, index, arr[index]);
        } else {
          let arr = JSON.parse(JSON.stringify(this.contactListChild));
          arr[index - 1].isdisabledsave = true
          arr[index - 1].saveType = ''
          this.$set(this.contactListChild, index - 1, arr[index - 1]);
        }

      }
      this.$message.success('success');
    } else {
      this.$message.error(data.commonout.errmsg);
    }
  }

  private ischeckedWhatsapp(index: number, val: any, flag: any) {
    if (flag == '99') {
      this.contactSelfListChild[index].checkedWhatsapp = val
      this.contactSelfListChild[index].isdisabledsave = false
      this.contactSelfListChild[index].saveType = 'success'
    } else {
      this.contactListChild[index].checkedWhatsapp = val
      this.contactListChild[index].isdisabledsave = false
      this.contactListChild[index].saveType = 'success'
    }
  }
  // 获取本人其他手机号
  private async getCustomerOtherMobile() {
    const { setGetWhatsAppMsgMapReq, getCustomerOtherMobileRequest }: any = await import(
      "@/request/getCustomerOtherMobile"
    );
    let data = await getCustomerOtherMobileRequest.handleHttp(
      setGetWhatsAppMsgMapReq({
        ItemId: this.itemId,
        OrderId: this.ticketData.orderid,
        AccountId: this.customerId,
        Identity: this.identity
      }),
      this
    );
    if (data.right) {
      this.$emit("getCustomerOtherMobileAction", {
        isAsking: true
      });
    }
  }
  // 查看联系人二列表
  private checkContactTwoList() {
    this.isContactListDialogue = true;
  }
  // checkCalllog
  private checkCalllog() {
    this.isShowCallLog = true;
  }

  private closeAction(res: boolean) {
    this.isContactListDialogue = false;
  }
  
  // 联系人跳转
  private navCustomer() {
    this.$router.push({
      path: "customerInfo",
      query: {
        id: this.customerId,
        appname: this.ticketData.appname,
      }
    });
  }
  private dwMakeDialogFuc(
    phone: any,
    supplier: number,
    relation: number
  ) {
    // dial拨打方式：0-手动，1-自动
    let dialway = this.$route.query.phone ? 1 : 0;
    return {
      assignuId: this.ticketData.assignuid,
      phoneNumber: phone + "",
      supplier: supplier,
      orderId: this.ticketData.orderid,
      ticketType: this.ticketData.itemid,
      ticketId: this.ticketData.id,
      opuId: Number(localGet("userid")),
      dialway: dialway
    };
  }
  // 打電話 num, innerItem.id, item.relation
  private async makeDialog(
    phone: any,
    supplier: number,
    relation: number
  ) {
    this.$emit("makeDialogueAction", {
      reshowCaller: relation, // 关系
      reshowCallerjPhone: phone, // 拨打号码
      phoneTime: timeFormat(new Date().getTime()), // 默认拨打时间  yyyy-MM-dd HH:mm:ss
      communicationWay: "1"
    });
    const { makeDial }: any = await import("@/request/makeDial");
    let res = await makeDial(
      this.dwMakeDialogFuc(phone, supplier, relation),
      this
    );
    if (res) {
      this.$emit("makeDialogueResult", {
        dialid: res.dialid
      });
    }
  }
}
